import { schema } from "normalizr";
import { Asset } from "records/asset";

export const AssetSchema = new schema.Entity("asset", {}, { idAttribute: "asset_id" });
(AssetSchema as any).record = Asset;
